export enum PaymentMethodTypeEnum {
    all = 'all',
    important = 'important',
}
